export default __webpack_public_path__ + "static/goal-screen-21ecffe078063a1896f86ae38fede81f.png";